"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BrandSwitch = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _menuButton = require("@reach/menu-button");
var _Icon = require("../Icons/PetSure/Icon");
var _objectHelpers = require("../../../helpers/objectHelpers");
var _brandContextProvider = require("../../../contextProviders/brandContextProvider");
require("./brandSwitch.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/forbid-prop-types */

const BrandSwitch = _ref => {
  let {
    brandConfigs,
    customContext,
    customActiveBrands,
    onBrandSelect = () => {}
  } = _ref;
  const brandContext = customContext || _brandContextProvider.BrandContext;
  const activeBrands = (0, _objectHelpers.DeepMergeObjects)({
    baseObject: brandConfigs,
    overrideObject: customActiveBrands || {}
  });
  const {
    applyBrandContext
  } = (0, _react.useContext)(brandContext);
  const [activeBrandKey, setActiveBrandKey] = (0, _react.useState)(activeBrands.default.theme.brand.key);
  const [activeBrandLabel, setActiveBrandLabel] = (0, _react.useState)(activeBrands.default.theme.brand.title);
  const HandleBrandChange = brandKey => {
    if (brandKey !== activeBrandKey) {
      const {
        theme
      } = activeBrands[brandKey];
      const {
        brand: {
          title
        }
      } = theme;
      setActiveBrandKey(brandKey);
      setActiveBrandLabel(title);
      applyBrandContext(activeBrands[brandKey]);
      onBrandSelect(activeBrands[brandKey], brandKey);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "brandSelector"
  }, /*#__PURE__*/_react.default.createElement(_menuButton.Menu, null, /*#__PURE__*/_react.default.createElement(_menuButton.MenuButton, {
    id: "brandMenu_trigger",
    className: "button brandInfoLink"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Brand ", "".concat(activeBrandLabel)), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "caret_down"
  })), /*#__PURE__*/_react.default.createElement(_menuButton.MenuList, {
    className: "brandMenuPopover"
  }, Object.keys(activeBrands).map(brandKey => /*#__PURE__*/_react.default.createElement(_menuButton.MenuItem, {
    as: "button",
    key: "brandSelector_".concat(brandKey),
    onSelect: () => HandleBrandChange(brandKey)
  }, brandKey)))));
};
exports.BrandSwitch = BrandSwitch;
BrandSwitch.propTypes = {
  brandConfigs: _propTypes.default.any,
  customContext: _propTypes.default.any,
  customActiveBrands: _propTypes.default.any,
  onBrandSelect: _propTypes.default.func
};
var _default = exports.default = {
  BrandSwitch
};